<mat-form-field class="dxselect-field">
  <mat-label>Select Dx</mat-label>
  <mat-select [formControl]="dxListControl">
    <mat-option *ngFor="let dx of dxList$ | async" [value]="dx">
      {{ dx?.diagnosis }}
    </mat-option>
  </mat-select>
</mat-form-field>
